import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

export const WorkQualityToBMI = {
  label: "工作性質 vs BMI",
  key: "WorkQualityToBMI",
  path: "BMI/WorkQualityToBMI",
  api: "TCS_V_BMIItemsV",
  render: (options) => <Diagram.BMI.WorkQualityToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "工作性質",
      field: "工作性質",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
